export default "__VITE_ASSET__CikRtgJP__"